import { render, staticRenderFns } from "./Disable2FA.vue?vue&type=template&id=97e8773c"
import script from "./Disable2FA.vue?vue&type=script&lang=js"
export * from "./Disable2FA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97e8773c')) {
      api.createRecord('97e8773c', component.options)
    } else {
      api.reload('97e8773c', component.options)
    }
    module.hot.accept("./Disable2FA.vue?vue&type=template&id=97e8773c", function () {
      api.rerender('97e8773c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmailAccounts/Disable2FA.vue"
export default component.exports